import { CALENDAR_TYPE } from "../Models/Common";

import useCalendarsStore from "../Store";

import { hasValue } from "@/Utils/Objects";
import { isValidString } from "@/Utils/String";

const RemoveFilterByPatientActionHandler = (calendarUuid: string): void => {
  const calendarsStore = useCalendarsStore();

  const customCalendar = calendarsStore.calendars.find(
    (c) => c.type === CALENDAR_TYPE.FILTER && c.uuid === calendarUuid
  );

  if (hasValue(customCalendar)) {
    calendarsStore.calendars = calendarsStore.calendars.filter((c) => c.uuid !== calendarUuid);

    if (
      !isValidString(customCalendar.originCalendarUuid) ||
      !calendarsStore.calendarsMap.has(customCalendar.originCalendarUuid)
    ) {
      calendarsStore.events = calendarsStore.events.filter((e) => e.calendarUuid !== calendarUuid);
    } else {
      calendarsStore.events = calendarsStore.events.map((e) => {
        if (e.calendarUuid === calendarUuid) {
          return { ...e, calendarUuid: customCalendar.originCalendarUuid as string };
        }

        return e;
      });
    }
  }
};

export default RemoveFilterByPatientActionHandler;
